/* 专家统一state */

export default {
  expertInfo: {
    avatar: null,
    id: null,
    introduction: null,
    name: null,
    title: null,
    token: null                   // 专家token
  }, // 专家信息
  audio: {
    serverId: null,
    speech: null,
    isUpload: false              // 是否是正在上传中的状态
  }, // 微信音频
  replyMessage: null,    // 被回答的消息
  livePopupVisible: false, // 直播间图片空间弹出状态
  isActive: false, // 直播间编辑选项卡状态
  issues: {
    hasNextPage: false,
    list: []
  }, // 问题列表
  startRecordTime: null, // 开始录制时间
  imageLocalIds: [], // 微信上传图片返回的localId数组
  sendImageLocalIds: [], // 发送图片消息时微信返回的localId数组
  materialPictureList: [], // 图片素材列表
  hasPictures: true, // 是否还有图片
  hasPPTs: true,     // 是否还有PPT
  materialaAudioList: [], // 音频素材列表
  materialaVideoList: [], // 视频素材列表
  materialPPTList: [],    // PPT素材列表
  replayMessageIds: [], // 已回复的消息id
  slides: {               // 幻灯片
    hasSlides: false,      // 是否有幻灯片
    list: []             // 幻灯片列表
  },
  mediaId: null,           // 返回服务器端id
  isUpdateVideo: false,           // 用户是否操纵发送按钮
  courseMsgList: {
    curpage: 0,
    list: [],
    hasNextPage: false
  },
  weeks: [0, 0, 0, 0, 0, 0, 0], // 专家答专家端工作日期
  guestbookList: { // 专家所有课程列表
    curpage: 1,
    dataList: [],
    hasNextPage: false,
    totalCount: 0
  },
  imMsgInfo: {}          // 已完成订单IM消息
};



// WEBPACK FOOTER //
// ./src/store/expert/state.expert.js